// Web mock for react-native-config
// This provides environment configuration for web builds
// Note: webpack DefinePlugin injects these values at build time via string replacement

const Config = {
  // API Configuration - injected by webpack DefinePlugin
  API_BASE_URL: process.env.API_BASE_URL || '',
  API_TIMEOUT: process.env.API_TIMEOUT || '30000',
  API_VERSION: 'v1',

  // CardConnect Configuration - injected by webpack DefinePlugin
  CARDCONNECT_URL: process.env.CARDCONNECT_URL || 'https://fts-uat.cardconnect.com',
  CARDCONNECT_SDK_URL: process.env.CARDCONNECT_SDK_URL || 'https://fts-uat.cardconnect.com/assets/js/cardconnect.js',

  // Environment Configuration - injected by webpack DefinePlugin
  ENVIRONMENT: process.env.ENVIRONMENT || (process.env.NODE_ENV === 'production' ? 'PRODUCTION' : 'DEVELOPMENT'),
  
  // Feature Flags - injected by webpack DefinePlugin
  LAUNCH_DARKLY_KEY: process.env.LAUNCH_DARKLY_KEY || '',
  REACT_APP_ENABLE_GOOGLE_SIGNIN_DEV: process.env.REACT_APP_ENABLE_GOOGLE_SIGNIN_DEV || 'false',
  
  // URLs - injected by webpack DefinePlugin
  DEFAULT_APP_URL: process.env.DEFAULT_APP_URL || '',
  DEFAULT_TERMS_URL: process.env.DEFAULT_TERMS_URL || '',
  DEFAULT_PRIVACY_URL: process.env.DEFAULT_PRIVACY_URL || '',

  // DataDog - injected by webpack DefinePlugin
  DATADOG_CLIENT_TOKEN: process.env.DATADOG_CLIENT_TOKEN || '',

  // Debug Configuration (hardcoded for web)
  ENABLE_ANALYTICS: 'true',
  ENABLE_CRASH_REPORTING: 'true',
  ENABLE_PERFORMANCE_MONITORING: 'true',
  DEBUG_NETWORK: 'false',
  DEBUG_REDUX: 'false',

  // App Configuration (hardcoded for web)
  APP_NAME: 'Resio',
  APP_VERSION: '1.0.0',
  BUILD_NUMBER: '1',

  // Authentication (hardcoded for web)
  AUTH_TIMEOUT: '3600000', // 1 hour
  REFRESH_TOKEN_THRESHOLD: '300000', // 5 minutes
  
  // Storage (hardcoded for web)
  STORAGE_ENCRYPTION_KEY: 'resio-web-storage-key',
  
  // Third-party Services (hardcoded for web)
  SENTRY_DSN: '',
  MIXPANEL_TOKEN: '',
  
  // Web-specific configurations
  WEB_BASE_URL: 'http://localhost:3000',
  WEB_SOCKET_URL: 'ws://localhost:3001',
  
  // Development helpers
  MOCK_API: 'false',
  BYPASS_AUTH: 'false',
};

// Add any missing properties that might be expected
const handler = {
  get(target, prop) {
    if (prop in target) {
      return target[prop];
    }
    
    // Return undefined for unknown properties (matches react-native-config behavior)
    return undefined;
  }
};

export default new Proxy(Config, handler);
